import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import { showNotification } from "react-admin";

import { startKiosk } from "../lib/serverCommands";

const showStyle = {
  button: {
    margin: "5px",
  },
};

class ConnectButton extends Component {
  handleClick = () => {
    const { showNotification: shn, kiosk } = this.props;

    startKiosk({ ...kiosk })
      .then(() => shn("notification.startOfSell"))
      .catch(err => {
        shn("notification.errorSending"); // TODO: message
        console.error("Error sending start kiosk message", err);
      });
  };

  render() {
    const { translate } = this.context;
    const { kiosk } = this.props;
    return (
      <Button
        style={showStyle.button}
        color="primary"
        variant="contained"
        disabled={kiosk.status !== 1}
        onClick={this.handleClick}
      >
        {translate("button.connect")}
      </Button>
    );
  }
}

ConnectButton.propTypes = {
  showNotification: PropTypes.func,
};
ConnectButton.contextTypes = {
  translate: PropTypes.func,
};

export default connect(
  null,
  {
    showNotification,
  }
)(ConnectButton);



// WEBPACK FOOTER //
// ./src/components/connectButton.js